import React from "react"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Link from "../components/Link"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"

export const options = {
  renderNode: {
    [BLOCKS.BLOCKQUOTE]: (node, children) => {
      //console.log("BLOCKQUOTE")
      return (
        <blockquote>
          <div className="quote-header">"QUOTE</div>
          <p>{children.map(child => child)}</p>{" "}
          {/* Ensure children are rendered properly */}
        </blockquote>
      )
    },
    [INLINES.HYPERLINK]: (node, children) => {
      // make sure internal links open i same window:
      if (node.data.uri.includes("emento.dk")) {
        return <Link to={node.data.uri}>{children}</Link>
      }
      if (node.data.uri.includes("vimeo.com")) {
        //console.log("node.data.uri: " + node.data.uri)
        const vimeoid = node.data.uri.replace("https://vimeo.com/", "")
        const playeruri = "https://player.vimeo.com/video/" + vimeoid
        //const vimeouri = "https://vimeo.com/" + vimeoid
        return (
          <div className="blog-video-container">
            <div className="iframe-wrapper">
              <iframe
                src={playeruri}
                title="Vimeo video player"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )
      }
      return (
        <Link to={node.data.uri} target="_blank" rel="noreferrer">
          {children}
        </Link>
      )
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      if (node.data.target) {
        //console.log("EMBED: " + node.data.target.__typename)
        if (node.data.target.__typename === "ContentfulHighlight") {
          return (
            <div className="case-study-highlight">
              <div className="case-study-highlight-body">
                {node.data.target.body && renderRichText(node.data.target.body)}
              </div>
              <div className="case-study-highlight-source">
                {node.data.target.source}
              </div>
            </div>
          )
        }
        if (node.data.target.__typename === "ContentfulMicrocopy") {
          if (node.data.target.key === "takeaway") {
            return (
              <div className="key-takeaway">
                <div className="key-takeaway-body">
                  {node.data.target.value &&
                    renderRichText(node.data.target.value)}
                </div>
              </div>
            )
          }
        }
        if (node.data.target.__typename === "ContentfulArticle") {
          return (
            <Link
              to={`/articles/${node.data.target.slug}`}
              className="article-link"
            >
              <span className="article-teaser">Related article:</span>
              {node.data.target.title}
            </Link>
          )
        }
        if (node.data.target.__typename === "ContentfulVideo") {
          if (node.data.target.twentythreeid) {
            const videoSrc =
              "//sales-marketing.23video.com/v.ihtml/player.html?token=67d778803251f376958c92de2fbacbf2&source=embed&showDescriptions=0&photo%5fid=" +
              node.data.target.twentythreeid
            return (
              <div className="video-embed">
                <div className="video-player">
                  <iframe
                    src={videoSrc}
                    className="video-iframe"
                    frameBorder="0"
                    title="twentythree video player"
                    border="0"
                    scrolling="no"
                    mozAllowFullScreen={true}
                    webkitAllowFullScreen={true}
                    allowFullScreen={true}
                    allow="autoplay; fullscreen"
                  />
                </div>
              </div>
            )
          }
          if (node.data.target.youtubeId) {
            const youtubeSrc =
              "https://www.youtube.com/embed/" + node.data.target.youtubeId
            return (
              <div className="youtube-embed">
                <iframe
                  className="youtube-iframe"
                  src={youtubeSrc}
                  title="YouTube video player"
                  type="text/html"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )
          }
        }
      }
    },
    [BLOCKS.EMBEDDED_ASSET]: node => {
      // TODO: hvis et billede ikke har en sprog-version vises ingenting - kan det mon laves så den automatisk vælger den danske, hvis ikke der forefindes en engelsk?
      if (node.data.target.sys.type === "Link") {
        return <div></div>
      } else if (node.data.target.file.contentType === "application/pdf") {
        return (
          <div className="blogpost-pdf-embed">
            <a
              href={node.data.target.file.url}
              title={node.data.target.title}
              target="_blank"
              rel="noreferrer"
            >
              {node.data.target.title}
            </a>
          </div>
        )
      } else {
        return (
          <div className="blogpost-inline-image">
            <GatsbyImage
              image={getImage(node.data.target)}
              alt={node.data.target.description}
            />
            <div className="blogpost-image-description">
              {node.data.target.description} &copy; Emento
            </div>
          </div>
        )
      }
    },
  },
}

export const renderLinkedIn = linkedIn => {
  return (
    <a
      href={`https://www.linkedin.com/in/${linkedIn}`}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className="social_icon"
        src="/images/social_icons/Linkedin_1.png"
        alt="LinkedIn profile"
      />
    </a>
  )
}

export const renderTwitter = twitter => {
  return (
    <a
      href={`https://www.twitter.com/${twitter}`}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className="social_icon"
        src="/images/social_icons/Twitter_1.png"
        alt="Twitter profile"
      />
    </a>
  )
}
